module.exports = __webpack_public_path__ + "img/8U.92d1a72a.png";